import {createFileRoute} from '@tanstack/react-router';

import {MonitorSearchParams} from '~utils/routeUtil';

import {BaseLayout} from '~components/_layout/BaseLayout';
import {Dashboard} from '~components/dashboard/Dashboard';
import {DashboardChartsProvider} from 'src/contexts/DashboardChartsContext';
import {MonitorLiveModeProvider} from 'src/contexts/MonitorLiveModeContext';

export const Route = createFileRoute('/monitor')({
  component: MonitorPage,
  validateSearch: MonitorSearchParams.validate,
});

function MonitorPage() {
  return (
    <BaseLayout withTitleDivider customContentAndFooter>
      <MonitorLiveModeProvider>
        <DashboardChartsProvider>
          <Dashboard />
        </DashboardChartsProvider>
      </MonitorLiveModeProvider>
    </BaseLayout>
  );
}
